import type { RichContent } from 'ricos-schema';
import { GalleryOptions_Layout_Type } from 'ricos-schema';

import type { DraftContent } from '../../../../../types';

type TestValues = {
  type: GalleryOptions_Layout_Type;
  expectedOutput: RichContent;
  input: DraftContent;
};

export const testValues = [
  {
    type: GalleryOptions_Layout_Type.GRID,
    expectedOutput: {
      nodes: [
        {
          type: 'PARAGRAPH',
          id: 'zlfbn2',
          nodes: [],
          paragraphData: {
            textStyle: {
              textAlignment: 'AUTO',
            },
            indentation: 0,
          },
        },
        {
          type: 'GALLERY',
          id: 'ymn3g1',
          nodes: [],
          galleryData: {
            containerData: {
              width: {
                size: 'CONTENT',
              },
              spoiler: {
                enabled: false,
              },
              textWrap: true,
              alignment: 'CENTER',
            },
            items: [
              {
                image: {
                  media: {
                    src: {
                      url: '8bb438_4b9b9acb8d6c45deadbeeb0029b4bf5e.jpg',
                    },
                    width: 3483,
                    height: 4645,
                  },
                },
              },
              {
                image: {
                  media: {
                    src: {
                      url: '8bb438_4fa0352201a1431395c3c4d4b21e3481.jpg',
                    },
                    width: 3727,
                    height: 5600,
                  },
                },
              },
              {
                image: {
                  media: {
                    src: {
                      url: '8bb438_3ff588618aa2433faec50a49cd48fef5.jpg',
                    },
                    width: 5600,
                    height: 3733,
                  },
                },
              },
            ],
            options: {
              layout: {
                type: 'GRID',
                horizontalScroll: false,
                orientation: 'COLUMNS',
                numberOfColumns: 3,
              },
              item: {
                ratio: 1,
                crop: 'FILL',
              },
              thumbnails: {
                placement: 'NONE',
              },
            },
          },
        },
        {
          type: 'PARAGRAPH',
          id: '3p4h03',
          nodes: [],
          paragraphData: {
            textStyle: {
              textAlignment: 'AUTO',
            },
            indentation: 0,
          },
        },
      ],
      metadata: {
        version: 1,
        createdTimestamp: '2022-12-19T17:56:18.279Z',
        updatedTimestamp: '2022-12-19T17:56:18.279Z',
        id: '00c7fed7-27c1-4633-a0b5-159d32dd41fc',
      },
      documentStyle: {},
    },
    input: {
      blocks: [
        {
          key: 'zlfbn2',
          type: 'unstyled',
          text: '',
          depth: 0,
          inlineStyleRanges: [],
          entityRanges: [],
          data: {},
        },
        {
          key: 'ymn3g1',
          type: 'atomic',
          text: ' ',
          depth: 0,
          inlineStyleRanges: [],
          entityRanges: [
            {
              offset: 0,
              length: 1,
              key: 0,
            },
          ],
          data: {},
        },
        {
          key: '3p4h03',
          type: 'unstyled',
          text: '',
          depth: 0,
          inlineStyleRanges: [],
          entityRanges: [],
          data: {},
        },
      ],
      entityMap: {
        '0': {
          type: 'wix-draft-plugin-gallery',
          mutability: 'IMMUTABLE',
          data: {
            items: [
              {
                url: '8bb438_4b9b9acb8d6c45deadbeeb0029b4bf5e.jpg',
                metadata: {
                  height: 4645,
                  width: 3483,
                  type: 'image',
                },
              },
              {
                url: '8bb438_4fa0352201a1431395c3c4d4b21e3481.jpg',
                metadata: {
                  height: 5600,
                  width: 3727,
                  type: 'image',
                },
              },
              {
                url: '8bb438_3ff588618aa2433faec50a49cd48fef5.jpg',
                metadata: {
                  height: 3733,
                  width: 5600,
                  type: 'image',
                },
              },
            ],
            config: {
              size: 'content',
              alignment: 'center',
              spoiler: {
                enabled: false,
              },
              textWrap: 'wrap',
            },
            styles: {
              galleryLayout: 2,
              oneRow: false,
              isVertical: true,
              numberOfImagesPerRow: 3,
              cubeRatio: 1,
              cubeType: 'fill',
              galleryThumbnailsAlignment: 'none',
            },
          },
        },
      },
      documentStyle: {},
      VERSION: '9.5.18',
      ID: 'b7fd2f8f-8f14-4cb5-8842-6b13be8261ef',
    },
  },
  {
    type: GalleryOptions_Layout_Type.MASONRY,
    expectedOutput: {
      nodes: [
        {
          type: 'PARAGRAPH',
          id: 'zlfbn2',
          nodes: [],
          paragraphData: {
            textStyle: {
              textAlignment: 'AUTO',
            },
            indentation: 0,
          },
        },
        {
          type: 'GALLERY',
          id: 'ymn3g1',
          nodes: [],
          galleryData: {
            containerData: {
              width: {
                size: 'CONTENT',
              },
              spoiler: {
                enabled: false,
              },
              textWrap: true,
              alignment: 'CENTER',
            },
            items: [
              {
                image: {
                  media: {
                    src: {
                      url: '8bb438_4b9b9acb8d6c45deadbeeb0029b4bf5e.jpg',
                    },
                    width: 3483,
                    height: 4645,
                  },
                },
              },
              {
                image: {
                  media: {
                    src: {
                      url: '8bb438_4fa0352201a1431395c3c4d4b21e3481.jpg',
                    },
                    width: 3727,
                    height: 5600,
                  },
                },
              },
              {
                image: {
                  media: {
                    src: {
                      url: '8bb438_3ff588618aa2433faec50a49cd48fef5.jpg',
                    },
                    width: 5600,
                    height: 3733,
                  },
                },
              },
            ],
            options: {
              layout: {
                type: 'MASONRY',
                orientation: 'ROWS',
                numberOfColumns: 0,
              },
              item: {
                targetSize: 300,
                crop: 'FILL',
              },
              thumbnails: {
                placement: 'NONE',
              },
            },
          },
        },
        {
          type: 'PARAGRAPH',
          id: '3p4h03',
          nodes: [],
          paragraphData: {
            textStyle: {
              textAlignment: 'AUTO',
            },
            indentation: 0,
          },
        },
      ],
      metadata: {
        version: 1,
        createdTimestamp: '2022-12-19T17:56:18.279Z',
        updatedTimestamp: '2022-12-19T17:56:18.279Z',
        id: '00c7fed7-27c1-4633-a0b5-159d32dd41fc',
      },
      documentStyle: {},
    },
    input: {
      blocks: [
        {
          key: 'zlfbn2',
          type: 'unstyled',
          text: '',
          depth: 0,
          inlineStyleRanges: [],
          entityRanges: [],
          data: {},
        },
        {
          key: 'ymn3g1',
          type: 'atomic',
          text: ' ',
          depth: 0,
          inlineStyleRanges: [],
          entityRanges: [
            {
              offset: 0,
              length: 1,
              key: 0,
            },
          ],
          data: {},
        },
        {
          key: '3p4h03',
          type: 'unstyled',
          text: '',
          depth: 0,
          inlineStyleRanges: [],
          entityRanges: [],
          data: {},
        },
      ],
      entityMap: {
        '0': {
          type: 'wix-draft-plugin-gallery',
          mutability: 'IMMUTABLE',
          data: {
            items: [
              {
                url: '8bb438_4b9b9acb8d6c45deadbeeb0029b4bf5e.jpg',
                metadata: {
                  height: 4645,
                  width: 3483,
                  type: 'image',
                },
              },
              {
                url: '8bb438_4fa0352201a1431395c3c4d4b21e3481.jpg',
                metadata: {
                  height: 5600,
                  width: 3727,
                  type: 'image',
                },
              },
              {
                url: '8bb438_3ff588618aa2433faec50a49cd48fef5.jpg',
                metadata: {
                  height: 3733,
                  width: 5600,
                  type: 'image',
                },
              },
            ],
            config: {
              size: 'content',
              alignment: 'center',
              spoiler: {
                enabled: false,
              },
              textWrap: 'wrap',
            },
            styles: {
              galleryLayout: 1,
              isVertical: false,
              numberOfImagesPerRow: 0,
              gallerySizePx: 300,
              cubeType: 'fill',
              galleryThumbnailsAlignment: 'none',
            },
          },
        },
      },
      documentStyle: {},
      VERSION: '9.5.18',
      ID: 'b7fd2f8f-8f14-4cb5-8842-6b13be8261ef',
    },
  },
  {
    type: GalleryOptions_Layout_Type.COLLAGE,
    expectedOutput: {
      nodes: [
        {
          type: 'PARAGRAPH',
          id: 'zlfbn2',
          nodes: [],
          paragraphData: {
            textStyle: {
              textAlignment: 'AUTO',
            },
            indentation: 0,
          },
        },
        {
          type: 'GALLERY',
          id: 'ymn3g1',
          nodes: [],
          galleryData: {
            containerData: {
              width: {
                size: 'CONTENT',
              },
              spoiler: {
                enabled: false,
              },
              textWrap: true,
              alignment: 'CENTER',
            },
            items: [
              {
                image: {
                  media: {
                    src: {
                      url: '8bb438_4b9b9acb8d6c45deadbeeb0029b4bf5e.jpg',
                    },
                    width: 3483,
                    height: 4645,
                  },
                },
              },
              {
                image: {
                  media: {
                    src: {
                      url: '8bb438_4fa0352201a1431395c3c4d4b21e3481.jpg',
                    },
                    width: 3727,
                    height: 5600,
                  },
                },
              },
              {
                image: {
                  media: {
                    src: {
                      url: '8bb438_3ff588618aa2433faec50a49cd48fef5.jpg',
                    },
                    width: 5600,
                    height: 3733,
                  },
                },
              },
            ],
            options: {
              layout: {
                type: 'COLLAGE',
                horizontalScroll: false,
                orientation: 'COLUMNS',
              },
              item: {
                targetSize: 300,
                crop: 'FILL',
              },
              thumbnails: {
                placement: 'NONE',
              },
            },
          },
        },
        {
          type: 'PARAGRAPH',
          id: '3p4h03',
          nodes: [],
          paragraphData: {
            textStyle: {
              textAlignment: 'AUTO',
            },
            indentation: 0,
          },
        },
      ],
      metadata: {
        version: 1,
        createdTimestamp: '2022-12-19T17:56:18.279Z',
        updatedTimestamp: '2022-12-19T17:56:18.279Z',
        id: '00c7fed7-27c1-4633-a0b5-159d32dd41fc',
      },
      documentStyle: {},
    },
    input: {
      blocks: [
        {
          key: 'zlfbn2',
          type: 'unstyled',
          text: '',
          depth: 0,
          inlineStyleRanges: [],
          entityRanges: [],
          data: {},
        },
        {
          key: 'ymn3g1',
          type: 'atomic',
          text: ' ',
          depth: 0,
          inlineStyleRanges: [],
          entityRanges: [
            {
              offset: 0,
              length: 1,
              key: 0,
            },
          ],
          data: {},
        },
        {
          key: '3p4h03',
          type: 'unstyled',
          text: '',
          depth: 0,
          inlineStyleRanges: [],
          entityRanges: [],
          data: {},
        },
      ],
      entityMap: {
        '0': {
          type: 'wix-draft-plugin-gallery',
          mutability: 'IMMUTABLE',
          data: {
            items: [
              {
                url: '8bb438_4b9b9acb8d6c45deadbeeb0029b4bf5e.jpg',
                metadata: {
                  height: 4645,
                  width: 3483,
                  type: 'image',
                },
              },
              {
                url: '8bb438_4fa0352201a1431395c3c4d4b21e3481.jpg',
                metadata: {
                  height: 5600,
                  width: 3727,
                  type: 'image',
                },
              },
              {
                url: '8bb438_3ff588618aa2433faec50a49cd48fef5.jpg',
                metadata: {
                  height: 3733,
                  width: 5600,
                  type: 'image',
                },
              },
            ],
            config: {
              size: 'content',
              alignment: 'center',
              spoiler: {
                enabled: false,
              },
              textWrap: 'wrap',
            },
            styles: {
              galleryLayout: 0,
              oneRow: false,
              isVertical: true,
              gallerySizePx: 300,
              cubeType: 'fill',
              galleryThumbnailsAlignment: 'none',
            },
          },
        },
      },
      documentStyle: {},
      VERSION: '9.5.18',
      ID: 'b7fd2f8f-8f14-4cb5-8842-6b13be8261ef',
    },
  },
  {
    type: GalleryOptions_Layout_Type.THUMBNAIL,
    expectedOutput: {
      nodes: [
        {
          type: 'PARAGRAPH',
          id: 'zlfbn2',
          nodes: [],
          paragraphData: {
            textStyle: {
              textAlignment: 'AUTO',
            },
            indentation: 0,
          },
        },
        {
          type: 'GALLERY',
          id: 'ymn3g1',
          nodes: [],
          galleryData: {
            containerData: {
              width: {
                size: 'CONTENT',
              },
              spoiler: {
                enabled: false,
              },
              textWrap: true,
              alignment: 'CENTER',
            },
            items: [
              {
                image: {
                  media: {
                    src: {
                      url: '8bb438_4b9b9acb8d6c45deadbeeb0029b4bf5e.jpg',
                    },
                    width: 3483,
                    height: 4645,
                  },
                },
              },
              {
                image: {
                  media: {
                    src: {
                      url: '8bb438_4fa0352201a1431395c3c4d4b21e3481.jpg',
                    },
                    width: 3727,
                    height: 5600,
                  },
                },
              },
              {
                image: {
                  media: {
                    src: {
                      url: '8bb438_3ff588618aa2433faec50a49cd48fef5.jpg',
                    },
                    width: 5600,
                    height: 3733,
                  },
                },
              },
            ],
            options: {
              layout: {
                type: 'THUMBNAIL',
                orientation: 'ROWS',
              },
              item: {
                crop: 'FILL',
              },
              thumbnails: {
                placement: 'BOTTOM',
                spacing: 5,
              },
            },
          },
        },
        {
          type: 'PARAGRAPH',
          id: '3p4h03',
          nodes: [],
          paragraphData: {
            textStyle: {
              textAlignment: 'AUTO',
            },
            indentation: 0,
          },
        },
      ],
      metadata: {
        version: 1,
        createdTimestamp: '2022-12-19T17:56:18.279Z',
        updatedTimestamp: '2022-12-19T17:56:18.279Z',
        id: '00c7fed7-27c1-4633-a0b5-159d32dd41fc',
      },
      documentStyle: {},
    },
    input: {
      blocks: [
        {
          key: 'zlfbn2',
          type: 'unstyled',
          text: '',
          depth: 0,
          inlineStyleRanges: [],
          entityRanges: [],
          data: {},
        },
        {
          key: 'ymn3g1',
          type: 'atomic',
          text: ' ',
          depth: 0,
          inlineStyleRanges: [],
          entityRanges: [
            {
              offset: 0,
              length: 1,
              key: 0,
            },
          ],
          data: {},
        },
        {
          key: '3p4h03',
          type: 'unstyled',
          text: '',
          depth: 0,
          inlineStyleRanges: [],
          entityRanges: [],
          data: {},
        },
      ],
      entityMap: {
        '0': {
          type: 'wix-draft-plugin-gallery',
          mutability: 'IMMUTABLE',
          data: {
            items: [
              {
                url: '8bb438_4b9b9acb8d6c45deadbeeb0029b4bf5e.jpg',
                metadata: {
                  height: 4645,
                  width: 3483,
                  type: 'image',
                },
              },
              {
                url: '8bb438_4fa0352201a1431395c3c4d4b21e3481.jpg',
                metadata: {
                  height: 5600,
                  width: 3727,
                  type: 'image',
                },
              },
              {
                url: '8bb438_3ff588618aa2433faec50a49cd48fef5.jpg',
                metadata: {
                  height: 3733,
                  width: 5600,
                  type: 'image',
                },
              },
            ],
            config: {
              size: 'content',
              alignment: 'center',
              spoiler: {
                enabled: false,
              },
              textWrap: 'wrap',
            },
            styles: {
              galleryLayout: 3,
              isVertical: false,
              cubeType: 'fill',
              galleryThumbnailsAlignment: 'bottom',
              thumbnailSpacings: 5,
            },
          },
        },
      },
      documentStyle: {},
      VERSION: '9.5.18',
      ID: 'b7fd2f8f-8f14-4cb5-8842-6b13be8261ef',
    },
  },
  {
    type: GalleryOptions_Layout_Type.SLIDESHOW,
    expectedOutput: {
      nodes: [
        {
          type: 'PARAGRAPH',
          id: 'zlfbn2',
          nodes: [],
          paragraphData: {
            textStyle: {
              textAlignment: 'AUTO',
            },
            indentation: 0,
          },
        },
        {
          type: 'GALLERY',
          id: 'ymn3g1',
          nodes: [],
          galleryData: {
            containerData: {
              width: {
                size: 'CONTENT',
              },
              spoiler: {
                enabled: false,
              },
              textWrap: true,
              alignment: 'CENTER',
            },
            items: [
              {
                image: {
                  media: {
                    src: {
                      url: '8bb438_4b9b9acb8d6c45deadbeeb0029b4bf5e.jpg',
                    },
                    width: 3483,
                    height: 4645,
                  },
                },
              },
              {
                image: {
                  media: {
                    src: {
                      url: '8bb438_4fa0352201a1431395c3c4d4b21e3481.jpg',
                    },
                    width: 3727,
                    height: 5600,
                  },
                },
              },
              {
                image: {
                  media: {
                    src: {
                      url: '8bb438_3ff588618aa2433faec50a49cd48fef5.jpg',
                    },
                    width: 5600,
                    height: 3733,
                  },
                },
              },
            ],
            options: {
              layout: {
                type: 'FULLSIZE',
                orientation: 'ROWS',
              },
              item: {
                crop: 'FILL',
              },
              thumbnails: {
                placement: 'NONE',
              },
            },
          },
        },
        {
          type: 'PARAGRAPH',
          id: '3p4h03',
          nodes: [],
          paragraphData: {
            textStyle: {
              textAlignment: 'AUTO',
            },
            indentation: 0,
          },
        },
      ],
      metadata: {
        version: 1,
        createdTimestamp: '2022-12-19T17:56:18.279Z',
        updatedTimestamp: '2022-12-19T17:56:18.279Z',
        id: '00c7fed7-27c1-4633-a0b5-159d32dd41fc',
      },
      documentStyle: {},
    },
    input: {
      blocks: [
        {
          key: 'zlfbn2',
          type: 'unstyled',
          text: '',
          depth: 0,
          inlineStyleRanges: [],
          entityRanges: [],
          data: {},
        },
        {
          key: 'ymn3g1',
          type: 'atomic',
          text: ' ',
          depth: 0,
          inlineStyleRanges: [],
          entityRanges: [
            {
              offset: 0,
              length: 1,
              key: 0,
            },
          ],
          data: {},
        },
        {
          key: '3p4h03',
          type: 'unstyled',
          text: '',
          depth: 0,
          inlineStyleRanges: [],
          entityRanges: [],
          data: {},
        },
      ],
      entityMap: {
        '0': {
          type: 'wix-draft-plugin-gallery',
          mutability: 'IMMUTABLE',
          data: {
            items: [
              {
                url: '8bb438_4b9b9acb8d6c45deadbeeb0029b4bf5e.jpg',
                metadata: {
                  height: 4645,
                  width: 3483,
                  type: 'image',
                },
              },
              {
                url: '8bb438_4fa0352201a1431395c3c4d4b21e3481.jpg',
                metadata: {
                  height: 5600,
                  width: 3727,
                  type: 'image',
                },
              },
              {
                url: '8bb438_3ff588618aa2433faec50a49cd48fef5.jpg',
                metadata: {
                  height: 3733,
                  width: 5600,
                  type: 'image',
                },
              },
            ],
            config: {
              size: 'content',
              alignment: 'center',
              spoiler: {
                enabled: false,
              },
              textWrap: 'wrap',
            },
            styles: {
              galleryLayout: 9,
              isVertical: false,
              cubeType: 'fill',
              galleryThumbnailsAlignment: 'none',
            },
          },
        },
      },
      documentStyle: {},
      VERSION: '9.5.18',
      ID: 'b7fd2f8f-8f14-4cb5-8842-6b13be8261ef',
    },
  },
  {
    type: GalleryOptions_Layout_Type.PANORAMA,
    expectedOutput: {
      nodes: [
        {
          type: 'PARAGRAPH',
          id: 'zlfbn2',
          nodes: [],
          paragraphData: {
            textStyle: {
              textAlignment: 'AUTO',
            },
            indentation: 0,
          },
        },
        {
          type: 'GALLERY',
          id: 'ymn3g1',
          nodes: [],
          galleryData: {
            containerData: {
              width: {
                size: 'CONTENT',
              },
              spoiler: {
                enabled: false,
              },
              textWrap: true,
              alignment: 'CENTER',
            },
            items: [
              {
                image: {
                  media: {
                    src: {
                      url: '8bb438_4b9b9acb8d6c45deadbeeb0029b4bf5e.jpg',
                    },
                    width: 3483,
                    height: 4645,
                  },
                },
              },
              {
                image: {
                  media: {
                    src: {
                      url: '8bb438_4fa0352201a1431395c3c4d4b21e3481.jpg',
                    },
                    width: 3727,
                    height: 5600,
                  },
                },
              },
              {
                image: {
                  media: {
                    src: {
                      url: '8bb438_3ff588618aa2433faec50a49cd48fef5.jpg',
                    },
                    width: 5600,
                    height: 3733,
                  },
                },
              },
            ],
            options: {
              layout: {
                type: 'PANORAMA',
                orientation: 'ROWS',
              },
              item: {
                crop: 'FILL',
              },
              thumbnails: {
                placement: 'NONE',
              },
            },
          },
        },
        {
          type: 'PARAGRAPH',
          id: '3p4h03',
          nodes: [],
          paragraphData: {
            textStyle: {
              textAlignment: 'AUTO',
            },
            indentation: 0,
          },
        },
      ],
      metadata: {
        version: 1,
        createdTimestamp: '2022-12-19T17:56:18.279Z',
        updatedTimestamp: '2022-12-19T17:56:18.279Z',
        id: '00c7fed7-27c1-4633-a0b5-159d32dd41fc',
      },
      documentStyle: {},
    },
    input: {
      blocks: [
        {
          key: 'zlfbn2',
          type: 'unstyled',
          text: '',
          depth: 0,
          inlineStyleRanges: [],
          entityRanges: [],
          data: {},
        },
        {
          key: 'ymn3g1',
          type: 'atomic',
          text: ' ',
          depth: 0,
          inlineStyleRanges: [],
          entityRanges: [
            {
              offset: 0,
              length: 1,
              key: 0,
            },
          ],
          data: {},
        },
        {
          key: '3p4h03',
          type: 'unstyled',
          text: '',
          depth: 0,
          inlineStyleRanges: [],
          entityRanges: [],
          data: {},
        },
      ],
      entityMap: {
        '0': {
          type: 'wix-draft-plugin-gallery',
          mutability: 'IMMUTABLE',
          data: {
            items: [
              {
                url: '8bb438_4b9b9acb8d6c45deadbeeb0029b4bf5e.jpg',
                metadata: {
                  height: 4645,
                  width: 3483,
                  type: 'image',
                },
              },
              {
                url: '8bb438_4fa0352201a1431395c3c4d4b21e3481.jpg',
                metadata: {
                  height: 5600,
                  width: 3727,
                  type: 'image',
                },
              },
              {
                url: '8bb438_3ff588618aa2433faec50a49cd48fef5.jpg',
                metadata: {
                  height: 3733,
                  width: 5600,
                  type: 'image',
                },
              },
            ],
            config: {
              size: 'content',
              alignment: 'center',
              spoiler: {
                enabled: false,
              },
              textWrap: 'wrap',
            },
            styles: {
              galleryLayout: 6,
              isVertical: false,
              cubeType: 'fill',
              galleryThumbnailsAlignment: 'none',
            },
          },
        },
      },
      documentStyle: {},
      VERSION: '9.5.18',
      ID: 'b7fd2f8f-8f14-4cb5-8842-6b13be8261ef',
    },
  },
  {
    type: GalleryOptions_Layout_Type.COLUMN,
    expectedOutput: {
      nodes: [
        {
          type: 'PARAGRAPH',
          id: 'zlfbn2',
          nodes: [],
          paragraphData: {
            textStyle: {
              textAlignment: 'AUTO',
            },
            indentation: 0,
          },
        },
        {
          type: 'GALLERY',
          id: 'ymn3g1',
          nodes: [],
          galleryData: {
            containerData: {
              width: {
                size: 'CONTENT',
              },
              spoiler: {
                enabled: false,
              },
              textWrap: true,
              alignment: 'CENTER',
            },
            items: [
              {
                image: {
                  media: {
                    src: {
                      url: '8bb438_4b9b9acb8d6c45deadbeeb0029b4bf5e.jpg',
                    },
                    width: 3483,
                    height: 4645,
                  },
                },
              },
              {
                image: {
                  media: {
                    src: {
                      url: '8bb438_4fa0352201a1431395c3c4d4b21e3481.jpg',
                    },
                    width: 3727,
                    height: 5600,
                  },
                },
              },
              {
                image: {
                  media: {
                    src: {
                      url: '8bb438_3ff588618aa2433faec50a49cd48fef5.jpg',
                    },
                    width: 5600,
                    height: 3733,
                  },
                },
              },
            ],
            options: {
              layout: {
                type: 'COLUMN',
                orientation: 'ROWS',
              },
              item: {
                crop: 'FILL',
              },
              thumbnails: {
                placement: 'NONE',
              },
            },
          },
        },
        {
          type: 'PARAGRAPH',
          id: '3p4h03',
          nodes: [],
          paragraphData: {
            textStyle: {
              textAlignment: 'AUTO',
            },
            indentation: 0,
          },
        },
      ],
      metadata: {
        version: 1,
        createdTimestamp: '2022-12-19T17:56:18.279Z',
        updatedTimestamp: '2022-12-19T17:56:18.279Z',
        id: '00c7fed7-27c1-4633-a0b5-159d32dd41fc',
      },
      documentStyle: {},
    },
    input: {
      blocks: [
        {
          key: 'zlfbn2',
          type: 'unstyled',
          text: '',
          depth: 0,
          inlineStyleRanges: [],
          entityRanges: [],
          data: {},
        },
        {
          key: 'ymn3g1',
          type: 'atomic',
          text: ' ',
          depth: 0,
          inlineStyleRanges: [],
          entityRanges: [
            {
              offset: 0,
              length: 1,
              key: 0,
            },
          ],
          data: {},
        },
        {
          key: '3p4h03',
          type: 'unstyled',
          text: '',
          depth: 0,
          inlineStyleRanges: [],
          entityRanges: [],
          data: {},
        },
      ],
      entityMap: {
        '0': {
          type: 'wix-draft-plugin-gallery',
          mutability: 'IMMUTABLE',
          data: {
            items: [
              {
                url: '8bb438_4b9b9acb8d6c45deadbeeb0029b4bf5e.jpg',
                metadata: {
                  height: 4645,
                  width: 3483,
                  type: 'image',
                },
              },
              {
                url: '8bb438_4fa0352201a1431395c3c4d4b21e3481.jpg',
                metadata: {
                  height: 5600,
                  width: 3727,
                  type: 'image',
                },
              },
              {
                url: '8bb438_3ff588618aa2433faec50a49cd48fef5.jpg',
                metadata: {
                  height: 3733,
                  width: 5600,
                  type: 'image',
                },
              },
            ],
            config: {
              size: 'content',
              alignment: 'center',
              spoiler: {
                enabled: false,
              },
              textWrap: 'wrap',
            },
            styles: {
              galleryLayout: 7,
              isVertical: false,
              cubeType: 'fill',
              galleryThumbnailsAlignment: 'none',
            },
          },
        },
      },
      documentStyle: {},
      VERSION: '9.5.18',
      ID: 'b7fd2f8f-8f14-4cb5-8842-6b13be8261ef',
    },
  },
  {
    type: GalleryOptions_Layout_Type.SLIDER,
    expectedOutput: {
      nodes: [
        {
          type: 'PARAGRAPH',
          id: 'zlfbn2',
          nodes: [],
          paragraphData: {
            textStyle: {
              textAlignment: 'AUTO',
            },
            indentation: 0,
          },
        },
        {
          type: 'GALLERY',
          id: 'ymn3g1',
          nodes: [],
          galleryData: {
            containerData: {
              width: {
                size: 'CONTENT',
              },
              spoiler: {
                enabled: false,
              },
              textWrap: true,
              alignment: 'CENTER',
            },
            items: [
              {
                image: {
                  media: {
                    src: {
                      url: '8bb438_4b9b9acb8d6c45deadbeeb0029b4bf5e.jpg',
                    },
                    width: 3483,
                    height: 4645,
                  },
                },
              },
              {
                image: {
                  media: {
                    src: {
                      url: '8bb438_4fa0352201a1431395c3c4d4b21e3481.jpg',
                    },
                    width: 3727,
                    height: 5600,
                  },
                },
              },
              {
                image: {
                  media: {
                    src: {
                      url: '8bb438_3ff588618aa2433faec50a49cd48fef5.jpg',
                    },
                    width: 5600,
                    height: 3733,
                  },
                },
              },
            ],
            options: {
              layout: {
                type: 'SLIDER',
                orientation: 'ROWS',
              },
              item: {
                ratio: 1.7777777777777777,
                crop: 'FIT',
              },
              thumbnails: {
                placement: 'NONE',
              },
            },
          },
        },
        {
          type: 'PARAGRAPH',
          id: '3p4h03',
          nodes: [],
          paragraphData: {
            textStyle: {
              textAlignment: 'AUTO',
            },
            indentation: 0,
          },
        },
      ],
      metadata: {
        version: 1,
        createdTimestamp: '2022-12-19T17:56:18.279Z',
        updatedTimestamp: '2022-12-19T17:56:18.279Z',
        id: '00c7fed7-27c1-4633-a0b5-159d32dd41fc',
      },
      documentStyle: {},
    },
    input: {
      blocks: [
        {
          key: 'zlfbn2',
          type: 'unstyled',
          text: '',
          depth: 0,
          inlineStyleRanges: [],
          entityRanges: [],
          data: {},
        },
        {
          key: 'ymn3g1',
          type: 'atomic',
          text: ' ',
          depth: 0,
          inlineStyleRanges: [],
          entityRanges: [
            {
              offset: 0,
              length: 1,
              key: 0,
            },
          ],
          data: {},
        },
        {
          key: '3p4h03',
          type: 'unstyled',
          text: '',
          depth: 0,
          inlineStyleRanges: [],
          entityRanges: [],
          data: {},
        },
      ],
      entityMap: {
        '0': {
          type: 'wix-draft-plugin-gallery',
          mutability: 'IMMUTABLE',
          data: {
            items: [
              {
                url: '8bb438_4b9b9acb8d6c45deadbeeb0029b4bf5e.jpg',
                metadata: {
                  height: 4645,
                  width: 3483,
                  type: 'image',
                },
              },
              {
                url: '8bb438_4fa0352201a1431395c3c4d4b21e3481.jpg',
                metadata: {
                  height: 5600,
                  width: 3727,
                  type: 'image',
                },
              },
              {
                url: '8bb438_3ff588618aa2433faec50a49cd48fef5.jpg',
                metadata: {
                  height: 3733,
                  width: 5600,
                  type: 'image',
                },
              },
            ],
            config: {
              size: 'content',
              alignment: 'center',
              spoiler: {
                enabled: false,
              },
              textWrap: 'wrap',
            },
            styles: {
              galleryLayout: 4,
              isVertical: false,
              cubeRatio: 1.7777777777777777,
              cubeType: 'fit',
              galleryThumbnailsAlignment: 'none',
            },
          },
        },
      },
      documentStyle: {},
      VERSION: '9.5.18',
      ID: 'b7fd2f8f-8f14-4cb5-8842-6b13be8261ef',
    },
  },
] as unknown as TestValues[];
